var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    { staticClass: "dp-f" },
    [
      _c("span", [_vm._v(_vm._s(_vm.text))]),
      _vm._v(" "),
      _c(
        "tool-tip",
        {
          staticClass: "upload-tip dp-f",
          attrs: { visiable: _vm.visiable, content: _vm.content }
        },
        [
          _c("img", {
            attrs: { src: require("../../images/doubt.png"), alt: "" },
            on: {
              mouseenter: function($event) {
                _vm.visiable = true
              },
              mouseout: function($event) {
                _vm.visiable = false
              }
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }